import React, { useEffect, useState } from "react";

const MouseFollower: React.FC = () => {
  const [position, setPosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const handleMouseMove = (event: MouseEvent) => {
      setPosition({ x: event.clientX, y: event.clientY });
    };

    window.addEventListener("mousemove", handleMouseMove);

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
    };
  }, []);

  return (
    <div
      style={{
        position: "fixed",
        top: position.y,
        left: position.x,
        width: "15px",
        height: "15px",
        border: "3px solid rgba(156,194,52,1)",
        backgroundColor: "#293962",
        //   background: "linear-gradient(90deg, rgba(156,194,52,1) 21%, rgba(60,134,60,1) 66%)",
        borderRadius: "50%",
        pointerEvents: "none", // Makes sure the follower doesn’t interfere with other mouse events
        transform: "translate(-50%, -50%)", // Centers the follower on the cursor
        transition: "transform 0.1s ease-out", // Smooth transition effect
      }}
    />
  );
};

export default MouseFollower;
